<template>
  <table class="table" v-if="items">
    <thead>
      <tr>
        <th></th>
        <th v-for="header of listLayout.headers" :key="header">
          {{ language[header] }}
        </th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <template v-for="(item, index) of items" :key="index">
        <tr
          :data-bs-target="'#report-detail-' + index"
          :aria-controls="'report-detail-' + index"
          data-bs-toggle="collapse"
          aria-expanded="false"
          @click="item.showDetail = !item.showDetail"
        >
          <td class="p-0">
            <div
              class="text-primary px-3 py-2"
              v-bind:class="{
                'bi-chevron-up': item.showDetail,
                'bi-chevron-down': !item.showDetail,
              }"
            ></div>
          </td>
          <td v-for="header of listLayout.headers" :key="header">
            {{ item[header] }}
          </td>
          <td>
            <a
              :href="`http://livemap.apdl.pt/#17/41.1815/-8.6940/shipid:${item.imo};AIS:0`"
              class="text-decoration-none"
              target="_black"
              v-if="listLayout.trackThisShip"
            >
              <i class="bi-geo pe-2">
                <p class="ms-2 d-inline">
                  {{ language[listLayout.trackThisShip] }}
                </p>
              </i>
            </a>
          </td>
        </tr>
        <tr>
          <td class="p-0"></td>
          <td colspan="6" class="p-0">
            <div class="collapse p-2 row" v-bind:id="'report-detail-' + index">
              <div v-for="pair in breakSix" :key="pair" class="col">
                <itemLayout
                  v-for="value in pair"
                  :key="value"
                  :label="language[value]"
                  :value="item[value]"
                  :imo="value == 'image' ? item?.imo : ''"
                />
              </div>
            </div>
          </td>
        </tr>
      </template>
    </tbody>
  </table>
</template>

<script>
import { computed } from "vue";
import DateTimeFormated from "../filters/date";
import store from "@/store";
import itemLayout from "@/components/itemLayout.vue";

export default {
  props: ["items", "listLayout"],
  components: {
    itemLayout,
  },
  setup() {
    const language = computed(() => store.getters.getLanguage());
    return {
      language,
    };
  },
  computed: {
    dateTimeFormated(date) {
      let d = new Date(date);
      return DateTimeFormated(d);
    },
    breakSix() {
      let p = [],
        copy = Object.values(this.listLayout.body);
      while (copy.length > 0) p.push(copy.splice(0, 7));
      return p;
    },
  },
};
</script>

